export default __webpack_public_path__ + "static/media/snowboard_dark.cff6371a.png";